"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpUserProfileDropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DpUserProfileDropdown_styled_1 = require("./DpUserProfileDropdown.styled");
var AvatarPopup_component_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/components/molecules/AvatarPopup/AvatarPopup.component"));
var DpUserProfileDropdown = function (_a) {
    var user = _a.user, roles = _a.roles, activeRole = _a.activeRole, onLogout = _a.onLogout, onRoleChange = _a.onRoleChange, impersonating = _a.impersonating, impersonatorName = _a.impersonatorName, onEndImpersonation = _a.onEndImpersonation;
    return ((0, jsx_runtime_1.jsx)(DpUserProfileDropdown_styled_1.StyledAvatarPopupContainer, { children: (0, jsx_runtime_1.jsx)(AvatarPopup_component_1.default, { user: user, onLogout: onLogout, onChangeRole: onRoleChange, currentRole: activeRole, availableRoles: roles, impersonating: impersonating, impersonator: impersonatorName, onEndImpersonation: onEndImpersonation, hideAppSelector: false, withKebabMenu: false }) }));
};
exports.DpUserProfileDropdown = DpUserProfileDropdown;
exports.DpUserProfileDropdown.displayName = 'AvatarPopup';
exports.default = exports.DpUserProfileDropdown;
